import React from 'react';
import {
  Box,
  IconButton,
  Avatar,
  Divider,
} from '@mui/material';
import { 
  Home, 
  History, 
  Tv, 
  HelpOutline, 
  PowerSettingsNew 
} from '@mui/icons-material';
import logoGemini from '/logo-gemini.png';

interface User {
  id: string;
  username: string;
  role: string;
}

interface SidebarProps {
  user: User | null;
  currentPage: string;
  onNavigate: (page: string) => void;
  onLogout: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ 
  user, 
  currentPage, 
  onNavigate, 
  onLogout 
}) => {
  const getButtonStyle = (page: string) => ({
    color: 'white',
    mb: 2,
    bgcolor: currentPage === page ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
    '&:hover': {
      bgcolor: 'rgba(255, 255, 255, 0.1)',
    },
  });

  return (
    <Box sx={{ 
      width: 80, 
      bgcolor: '#3d36fa', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      py: 3 
    }}>
      <Avatar 
        sx={{ 
          bgcolor: 'white', 
          width: 48, 
          height: 48, 
          mb: 4 
        }} 
        src={logoGemini} 
        alt="Gemini Logo" 
      />
      
      <IconButton 
        sx={getButtonStyle('dashboard')} 
        onClick={() => onNavigate('dashboard')}
      >
        <Home />
      </IconButton>
      
      <IconButton 
        sx={getButtonStyle('history')} 
        onClick={() => onNavigate('history')}
      >
        <History />
      </IconButton>
      
      <IconButton 
        sx={getButtonStyle('devices')} 
        onClick={() => onNavigate('devices')}
      >
        <Tv />
      </IconButton>
      
      <Box sx={{ flexGrow: 1 }} />
      
      <Divider sx={{ bgcolor: 'white', width: 40, mb: 2 }} />
      
      <IconButton 
        sx={{ color: 'white', mb: 2 }}
      >
        <HelpOutline />
      </IconButton>
      
      <IconButton 
        sx={{ 
          color: 'white', 
          bgcolor: '#ffb300', 
          mb: 1,
          '&:hover': {
            bgcolor: '#e6a200',
          }
        }} 
        onClick={onLogout}
      >
        <PowerSettingsNew />
      </IconButton>
    </Box>
  );
}; 